import {
  AfterContentInit,
  AfterViewInit,
  Component,
  ElementRef, forwardRef, Input,
  OnChanges,
  OnInit, QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {Options} from "@angular-slider/ngx-slider";
import {ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR} from "@angular/forms";
import {ValidationService} from "../validation.service";
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-amount-slider-field',
  templateUrl: './amount-slider-field.component.html',
  styleUrls: ['./amount-slider-field.component.sass'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AmountSliderFieldComponent),
      multi: true
    }
  ]
})
export class AmountSliderFieldComponent implements ControlValueAccessor {
  @Input() formGroup: FormGroup;
  @Input() fieldName: string;
  @Input() disableRequiredIdentifier: boolean = false;

  public brand;

  private _value = 850000
  public _isDisabled = false

  onChange: any = () => {
  }
  onTouch: any = () => {
  }

  public set value(v) {
    if (v !== undefined && this.value !== v) {
      const val = Number(v)
      this._value = val
      this.onChange(val)
    }
  }

  public get value() {
    return this._value
  }

  public options: Options = {
    showTicks: true,
    floor: 0,
    step: 5000,
    enforceStep: false,
    ceil: 1200000,
    ticksArray: [0, 100000, 500000, 850000, 1200000],
    hideLimitLabels: true,
    hidePointerLabels: true,
    showSelectionBar: false,
    disabled: this._isDisabled,
    getLegend: (value: number): string => {
      switch (value) {
        case 0:
          return '<span>0 ₽</span>';
        case 100000:
          return '<span>100 000 ₽</span>';
        case 500000:
          return '500 000 ₽';
        case 850000:
          return '850 000 ₽';
        case 1200000:
          return '1 200 000 ₽';
        default:
          return '';
      }
    },
    getPointerColor: (value: number): string => {
      if (value <= 60000) {
        return '#AF4E4E';
      }
      if (value <= 849000) {
        return '#D2C625';
      }
      return '#10CA00';
    }
  }

  constructor() {
    this.brand = environment.brand
  }

  writeValue(obj: any): void {
    this.value = obj
  }

  registerOnChange(fn: any): void {
    this.onChange = fn
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn
  }

  setDisabledState?(isDisabled: boolean): void {
    this._isDisabled = isDisabled
  }

  public validate() {
    if(this.disableRequiredIdentifier) {
      if(this.brand === 'VIVUS'){
        return 'fa fa-check vivus-style'
      } else {
        return 'fa fa-check'
      }
    } else {
      return ''
    }
  }
}
